/**
 * OutcomeGroup — public entry point for one terminal-outcome group inside the
 * expanded Closed area (SE-6862).
 *
 * The cap-lifting handler and the show-all state both come from
 * ClosedAreaContainer; the Container here owns only the cap itself — which
 * entries are visible and how many are hidden (SE-8019). Nested under the ClosedArea organism rather than
 * promoted to its own molecule directory — it has exactly one consumer and no
 * meaning outside the Closed area, the same reason ClosedCardRow and
 * CollapsedRail sit here.
 * @module features/player-kanban/components/organisms/ClosedArea/OutcomeGroup
 */

export { default } from "./OutcomeGroupContainer";
export type { OutcomeGroupContainerProps } from "./OutcomeGroupContainer";
export type { OutcomeGroupViewProps } from "./OutcomeGroupView";
